// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 239) return "blog.1.3.6.bundle.css";
	// return url for filenames based on template
	return "" + "owl-carousel" + "." + "dbd95f101c6b3c48bbd7" + ".css";
};